/** React libraries */
import React from 'react';
import { Col, Container, Row } from "react-bootstrap";

/** Custom components types, services */
import CertificatesList from "../../features/Certificates/CertificatesList";
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';

/** Styles */
import "./certificate.style.css";

const Certificate = () => {
    const userState = useSelector((state: RootState) => state.users);

    return (
        <>
            <main className="container-fluid dashboard-bg">
                <div className="main main-app">
                    <div className="d-flex">
                        <div className="p-4 w-100">
                            <div className="d-flex flex-column gap-1">
                                <div className="certificate-title">Logo Request Portal</div>
                                <div className="secondary-font fs-18">Select a Certificate to request use of a logo</div>
                            </div>
                            <hr className="pb-4"/>
                            <CertificatesList />
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default Certificate;
